import { createSlice } from '@reduxjs/toolkit';
import { rtkApi } from '../../../RTK/api/rtkApi';
import { ToolNameModel } from 'src/Models/ToolNameModel';

export interface IDropdownDataSlice {
  dropdownData: unknown[];
  appsList: ToolNameModel[];
}

const initialState = {
  dropdownData: [],
  appsList: [],
} as IDropdownDataSlice;

const dropdownDataSlice = createSlice({
  name: 'dropdownData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(rtkApi.endpoints.getDropdownData.matchFulfilled, (state, action) => {
      state.dropdownData = action.payload;
    });
    builder.addMatcher(rtkApi.endpoints.getDropdownDataCached.matchFulfilled, (state, action) => {
      state.dropdownData = action.payload;
    });
    builder.addMatcher(rtkApi.endpoints.GetToolsName.matchFulfilled, (state, action) => {
      const options: ToolNameModel[] = [];
      options.push({ id: -1, toolName: 'All' });
      options.push({ id: 0, toolName: 'Default' });
      const applist = action.payload;
      const applistSorted = applist.slice().sort((a, b) => (a.toolName > b.toolName ? 1 : -1));
      applistSorted.forEach((item: ToolNameModel) => {
        options.push({
          id: item.id,
          toolName: item.toolName,
        });
      });
      state.appsList = options;
    });
  },
});

export default dropdownDataSlice.reducer;
